import { http } from '../http';

export const getContactOverviewService = async (params) => {
  try {
    const { contactId, eventId } = params;

    const queryParams = Object.entries({ eventId })
      .reduce((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

    const response = await http.get(
      `/contacts/${contactId}/overview`,
      {
        baseURL: process.env.BFFV2_BASE_URL,
        params: queryParams,
      },
    );
    if (!response?.status === 200) {
      throw new Error("Can't get contact overview");
    }
    return response?.data;
  } catch (e) {
    console.error('something went wrong', e);
    return false;
  }
};

export default {
  getContactOverviewService,
};
